import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./BlogDetail.css";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        const response = await fetch(`https://kraafty-backend.onrender.com/api/get-blog-detail/?blog_pk=${id}`);
        const data = await response.json();
        setBlog(data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching blog detail:", error);
        setLoading(false);
      }
    };

    fetchBlogDetail();
  }, [id]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!blog) {
    return <div className="error">Blog not found</div>;
  }

  return (
    <div className="blog-detail-container">
      <Helmet>
        <title>{blog.title} | Kraafty</title>
        <link rel="canonical" href={`https://kraafty.com/blog/${id}`} />
      </Helmet>

      <div className="blog-content">
        <div className="blog-header">
          <h1 className="blog-title">{blog.title}</h1>
          <div className="blog-subtitle">Discover the Best Products</div>
        </div>

        <div className="blog-grid">
          <div className="blog-image-container">
            <img src={blog.image} alt={blog.title} className="blog-image" />
          </div>

          <div className="blog-info">
            <div className="blog-description" dangerouslySetInnerHTML={{ __html: blog.description }} />

            <div className="features-list">
              <h3>Key Features:</h3>
              <ul>
                <li>Consistent high quality</li>
                <li>Verified purity and freshness</li>
                <li>Reliable sourcing standards</li>
              </ul>
            </div>

            <div className="quote">
              "Freshness and quality are non-negotiable for authentic products."
            </div>

            <a
              href={blog.product_link}
              className="shop-now-button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Shop Now →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
